import axios from 'axios'
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, isSupported } from 'firebase/messaging'
import { firebaseConfig } from './firebase.config'

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Cloud Messaging and get a reference to the service

export let messaging = null

try {
  if (await isSupported()) {
    messaging = getMessaging(app)
  }
} catch (error) {}

export const requestPermission = async () => {
  console.log('Requesting permission...')
  try {
    if ('Notification' in window && Notification.permission === 'granted') {
      if (window.location.pathname !== '/subscription') {
        await generateToken()
      }
    } else {
      const permission = await Notification.requestPermission()

      if (permission === 'granted') {
        console.log('Notification permission granted.')
        await generateToken()
      }
    }
  } catch (error) {}
}

// PushManager.subscribe needs an *active* worker, and navigator.serviceWorker.ready
// only resolves once there is one. Bounded so a broken worker logs instead of hanging.
const getActiveServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) {
    return undefined
  }

  let timeoutId

  try {
    return await Promise.race([
      navigator.serviceWorker.ready,
      new Promise((resolve) => {
        timeoutId = setTimeout(() => resolve(undefined), 10000)
      }),
    ])
  } finally {
    clearTimeout(timeoutId)
  }
}

const generateToken = async () => {
  const serviceWorkerRegistration = await getActiveServiceWorker()

  getToken(messaging, {
    vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    ...(serviceWorkerRegistration ? { serviceWorkerRegistration } : {}),
  })
    .then((currentToken) => {
      if (currentToken) {
        try {
          const config = {
            withCredentials: true,
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }

          let deviceId = localStorage.getItem('deviceId')
          if (!deviceId) {
            deviceId = 'web' + Math.random().toString(20).substring(2, 14)
            localStorage.setItem('deviceId', deviceId)
          }
          axios
            .post(
              `${process.env.REACT_APP_API_URL}/device-tokens`,
              {
                deviceId: deviceId,
                deviceType: 'Web',
                token: currentToken,
              },
              config,
            )
            .catch(() => {})
        } catch (error) {
          console.log(error)
        }
      } else {
        console.log(
          'No registration token available. Request permission to generate one.',
        )
      }
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err)
    })
}
